import React from 'react';
// import {useHistory} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {DropdownButton, Dropdown} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {sagaActions} from '@modules/login/redux/saga';
import {get} from 'lodash';
import {useMsal} from '@azure/msal-react';

const UserDropdown = () => {
  // const history = useHistory();
  const {instance} = useMsal();
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.currentUser);

  const logOut = (event) => {
    event.preventDefault();
    dispatch({
      type: sagaActions.LOGOUT,
      payload: {},
    });
    // history.push('/login');
    instance.logoutRedirect();
  };

  return (
    <DropdownButton
      // menuAlign="right"
      variant="link"
      size="sm"
      title={
        <div
          style={{
            display: 'inline-block',
          }}
        >
          <i className="fa fa-circle mr-1" />
          <span className="d-none d-lg-inline">
            {get(user, 'Name', 'User')}
          </span>
        </div>
      }
      id="dropdown-menu-align-right-current-user"
      className="cce-current-user"
    >
      <Dropdown.Item eventKey="1">
        {t('header.user.accountSettings')}
      </Dropdown.Item>
      <Dropdown.Item eventKey="2" onClick={logOut}>
        {t('login.button.signOut')}
      </Dropdown.Item>
    </DropdownButton>
  );
};

export default UserDropdown;
